import { PageLocatorMap } from '../types/PageLocatorMap';

export const applyPurchaseTypePage = {
  footer: {
    root: 'apply-purchase-type-page.footer.root',
  },
  form: {
    h1: 'apply-purchase-type-page.form.h1',
    h2: 'apply-purchase-type-page.form.h2',
    radioGroupRoot: 'apply-purchase-type-page.form.radio-group-root',
    radioOption1: 'apply-purchase-type-page.form.radio-option1',
    radioOption2: 'apply-purchase-type-page.form.radio-option2',
    root: 'apply-purchase-type-page.form.root',
    submitButton: 'apply-purchase-type-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
